import { ChannelType, TemplateVariable, VariableFormat } from '../../../../../types/communication';

interface RecipientVariable {
    name: string;
    label: string;
    format: VariableFormat;
}

const EMAIL_RECIPIENT: RecipientVariable = { name: 'EMAIL', label: 'E-mail do destinatário', format: 'EMAIL' };
const PHONE_RECIPIENT: RecipientVariable = { name: 'PHONE_NUMBER', label: 'Telefone do destinatário', format: 'PHONE' };

export const recipientVariableFor = (channel: ChannelType): RecipientVariable | null => {
    if (channel === 'EMAIL') return EMAIL_RECIPIENT;
    if (channel === 'EXTERNAL_MESSAGE') return PHONE_RECIPIENT;
    return null;
};

export const recipientToken = (channel: ChannelType): string => {
    const variable = recipientVariableFor(channel);
    return variable ? `{{${variable.name}}}` : '';
};

export const recipientTemplateVariable = (channel: ChannelType): TemplateVariable | null => {
    const variable = recipientVariableFor(channel);
    if (!variable) return null;
    return { name: variable.name, label: variable.label, format: variable.format, required: true };
};
